import { __assign } from "tslib";
import React from 'react';
import { useState } from 'react';
import { Row } from 'react-bootstrap';
import Paginacion from './PaginacionXS';
export default function Paginador(_a) {
    var row = _a.row, mostrar = _a.mostrar, itens = _a.itens, style = _a.style, bodyStyle = _a.bodyStyle;
    var _b = useState(1), page = _b[0], setPage = _b[1];
    function filter(_k, i) {
        var init = (page - 1) * mostrar, fin = init + mostrar;
        return i >= init && i < fin;
    }
    function getRef(_a) {
        var codigo = _a.codigo, id = _a.id, status = _a.status, estado = _a.estado, estatus = _a.estatus;
        var key = 'key';
        if (status)
            key += status;
        if (estado)
            key += estado;
        if (estatus)
            key += estatus;
        if (codigo)
            key += codigo;
        if (id)
            key += id;
        if (key === 'key')
            return key + Math.random();
        return key;
    }
    function RowIten(d) {
        return React.createElement(React.Fragment, null, row(d));
    }
    function BodyContent() {
        var iten = itens.filter(filter);
        return (React.createElement("div", { className: 'w-100', style: __assign({ height: 'calc(100%  - 55px)' }, bodyStyle) }, iten.map(function (it) { return (React.createElement(RowIten, __assign({ key: getRef(it) }, it))); })));
    }
    return (React.createElement(Row, { className: 'd-flex flex-row w-100 p-0 m-0', style: style },
        React.createElement(BodyContent, null),
        React.createElement(Row, { className: 'd-flex flex-row w-100  p-0 m-0' },
            React.createElement("div", { className: 'm-1 mr-auto' }),
            React.createElement(Paginacion, { key: "page".concat(Math.random()), page: page, length: itens.length, mostrar: mostrar, setpage: setPage }))));
}
//# sourceMappingURL=Paginador.js.map